import makeStyles from '@material-ui/core/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
    root: {},
    mt5: {
        marginTop: theme.spacing(3),
        width: '100%',
    },
    mapContainer: {
        width: '100%',
        margin: '0 auto',
        height: '400px',
        border: '1px solid #ccc',
        marginTop: theme.spacing(2),
    },
    showMapButton: {
        cursor: 'pointer',
    },
    dialogRoot: {
        minHeight: '90%',
    },
    dialogTitle: {
        paddingBottom: 0,
    },
    dialogPaper: {
        minHeight: '90vh',
        maxHeight: '90vh',
    },
    dialogActions: {
        paddingTop: theme.spacing(3),
    },
    cancelButton: {
        marginLeft: theme.spacing(3),
    }
}));
